import {
  GET_ADMIN_CAMPAIGN_FULFILLMENT,
  GET_ADMIN_CAMPAIGN_FULFILLMENT_ERROR,
  GET_ADMIN_CAMPAIGN_FULFILLMENT_SUCCESS,
  EXPORT_ADMIN_CAMPAIGN_FULFILLMENT,
  EXPORT_ADMIN_CAMPAIGN_FULFILLMENT_SUCCESS,
  EXPORT_ADMIN_CAMPAIGN_FULFILLMENT_ERROR,
} from "./actionTypes"

export const getAdminCampaignFulfillment = (payload, paginated = false) => {
  return {
    type: GET_ADMIN_CAMPAIGN_FULFILLMENT,
    payload: payload,
    paginated,
  }
}

export const getAdminCampaignFulfillmentSuccess = (templates, meta = {}) => {
  return {
    type: GET_ADMIN_CAMPAIGN_FULFILLMENT_SUCCESS,
    payload: templates,
    meta,
  }
}

export const getAdminCampaignFulfillmentError = error => {
  return {
    type: GET_ADMIN_CAMPAIGN_FULFILLMENT_ERROR,
    payload: error,
  }
}

export const exportAdminCampaignFulfillment = (payload) => {
  return {
    type: EXPORT_ADMIN_CAMPAIGN_FULFILLMENT,
    payload: payload,
  }
}

export const exportAdminCampaignFulfillmentSuccess = (response) => {
  return {
    type: EXPORT_ADMIN_CAMPAIGN_FULFILLMENT_SUCCESS,
    payload: response,
  }
}

export const exportAdminCampaignFulfillmentError = (error) => {
  return {
    type: EXPORT_ADMIN_CAMPAIGN_FULFILLMENT_ERROR,
    payload: error,
  }
}
